import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notes',
   templateUrl: './notes.component.html',
    styleUrls: ['./notes.component.css']
})
export class NotesComponent {
  constructor(private router: Router) {
    this.downloadNotes();
  }

  downloadNotes() {
    this.router.navigate(['/DOA']);
    const link = document.createElement('a');
    link.href = 'assets/Notes.doc';
    link.download = 'Notes.doc';
    link.click();
    
  }
}